module.exports = __webpack_public_path__ + "img/market.30047c09.png";